import "../css/Faqs.css";

const faqs = [
  {
    q: "What are your opening hours?",
    a: "We’re open daily from evening until late night. Exact hours may vary by location.",
  },
  {
    q: "Do you offer plant-based milk?",
    a: "Yes. Oat and almond milk are available for all coffee drinks.",
  },
  {
    q: "Is Neo Café good for working or reading?",
    a: "Absolutely. Many guests visit for quiet work, reading, or late conversations.",
  },
  {
    q: "Do you take reservations?",
    a: "We operate on a walk-in basis to keep the experience relaxed and flexible.",
  },
  {
    q: "Is there Wi-Fi available?",
    a: "Yes, complimentary Wi-Fi is available for all guests.",
  },
];

const Faqs = () => {
  return (
    <main className="night-faqs">

      {/* INTRO */}
      <section className="faqs-intro">
        <h1>FAQs</h1>
        <p>
          A few things<br />
          you might want to know.
        </p>
      </section>

      {/* FAQ LIST */}
      <section className="faqs-list">
        {faqs.map((item, index) => (
          <div key={index} className="faq-item">
            <h3>{item.q}</h3>
            <p>{item.a}</p>
          </div>
        ))}
      </section>

      {/* CLOSING */}
      <section className="faqs-closing">
        <p>
          Still curious?<br />
          Visit us after dark.
        </p>
      </section>

    </main>
  );
};

export default Faqs;
